module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-big-gray-light-9ce74c46828f26d7af25e9c057bc0c43.svg";